export default __webpack_public_path__ + "static/media/modern-being-home.be3add52.png";